
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isSVG: false,
      isSVGMobile: false,
      svgHtml: null,
      svgHtmlMobile: null,
      imgSrc: null,
      imgSrcMobile: null,
      // imgWidth: null,
      // imgHeight: null,
      // imgAlt: null,
    }
  },

  mounted() {
    this.$nextTick(() => {
      // this.setImgAttr()
      // this.handleStoryblokAsset()
      // this.resolveSrc()
    })
  },
  methods: {
    // setImgAttr() {
    //   this.imgSrc = this.blok?.src?.filename
    //   this.imgAlt = this.alt || this.blok?.src?.alt
    //   this.imgWidth = this.width || this.blok?.width
    //   this.imgHeight = this.height || this.blok?.height
    // },
    async resolveSrc() {
      const isSvg = this.blok?.image?.filename?.includes('svg')
      const isSvgMobile = this.blok?.image_mobile?.filename?.includes('svg')

      if (isSvg) {
        this.isSVG = true

        // fetch svg raw html
        const rawHTML = await this.useFetchAsset(this.blok?.image?.filename)

        // this.mergeAttr()

        this.svgHtml = rawHTML
      } else {
        this.isSVG = false
        this.imgSrc = this.blok?.image?.filename
      }

      if (isSvgMobile) {
        this.isSVG = true

        // fetch svg raw html
        const rawHTMLMobile = await this.useFetchAsset(
          this.blok?.image_mobile?.filename
        )

        // this.mergeAttr()

        this.svgHtmlMobile = rawHTMLMobile
      } else {
        this.isSVGMobile = false
        this.imgSrcMobile = this.blok?.image_mobile?.filename
      }
    },
    async handleStoryblokAsset() {
      const isSvg = this.blok?.image?.filename?.includes('svg')

      if (isSvg) {
        this.isSVG = true

        // fetch svg raw html
        const rawHTML = await this.useFetchAsset(this.blok?.image?.filename)

        // this.mergeAttr()

        this.svgHtml = rawHTML
      } else {
        this.isSVG = false
      }
    },
    async useFetchAsset(url) {
      return await this.$axios
        .get(this.buildUrl(url))
        .then((res) => res.data)
        .catch((err) => console.warn(err))
    },
    buildUrl(url = '') {
      if (!url) return
      const protocol = 'https://'
      const [, domain] = url.split('https://')

      return protocol + 's3.amazonaws.com/' + domain
    },
    // mergeAttr(rawHTML) {
    //   // split raw html svg tag
    //   const splitHtmlFirst = rawHTML.substring(0, 4)
    //   const splitHtmlSecond = rawHTML.slice(4)

    //   // build attributes string
    //   const mergeAttrs = ` style="width: ${this.imgWidth}; height: ${this.imgHeight}"`
    //   console.log([splitHtmlFirst, mergeAttrs, splitHtmlSecond].join(''))
    //   return [splitHtmlFirst, mergeAttrs, splitHtmlSecond].join('')
    // },
  },
}
